import restApi from '@/utils/rest-api'

export default {
    getQuiz: (id) => {
        return restApi.get('quizzes/' + id)
    }
}
